import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { withRouter } from '../../util/withRouter';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, DropdownButton, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { DatePicker } from './components/DatePicker';
import Filter from './components/ReportFilter';
import NoData from '../../components/NoData/NoData';
import Loading from '../../components/Loading/Loading';
import Header from '../../components/Header/Header';
import Confirm from '../../components/Confirm/Confirm';

import {
  getFilters,
  setFilters,
  requestData,
  requestComparisonData,
  getPdf,
  getComparisonPdf,
  getCsv,
  selectStream,
  deleteStream,
  listAll,
  saveSelected,
  saveSelectedBreakdown,
  saveSelectedDateRange
} from './ReportActions';
import Views from './components/ExecDashboardView/Views';
import ReportTable from './components/ReportTable/ReportTable';
import SaveView from './components/ExecDashboardView/SaveView';
import LineChart from './components/LineChart';
import ValueStreamSelector from './components/ValueStreamSelector';
import SubscribeEDAddOn from '../../components/SubscribeEDAddOn/SubscribeEDAddOn';

import exportIcon from '../../assets/img/download.svg';
import cloudDownload from '../../assets/images/cloud-download-icon.svg';
import settingsIcon from '../../assets/img/settings-icon.svg';
import createIcon from '../../assets/img/createDashboard-icon.svg';
import lineChartOnIcon from '../../assets/img/line-chart-icon-on.svg';
import lineChartOffIcon from '../../assets/img/line-chart-icon-off.svg';


import dashboardIcon from '../../assets/img/dashboard.svg';
import deleteIcon from '../../assets/img/delete.svg';
import editIcon from '../../assets/images/edit-blue.svg';
import defaultBoardImg from '../../assets/images/stream-default-icon.jpg';

import expandIcon from '../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../assets/img/zoom-icon-on.svg';

import '../../util/moment-duration';
import { getBreakDownList } from '../../util/reportUtils';

import { PieChartWidget } from './components/PieChartWidget';

import {
  trackExecutiveFilterChange,
  trackReportConfigChange,
  trackExecutiveDashboardView } from '../../util/mixpanel';

import { getStreamAccessRights } from '../../util/permissions';
import { GridStackManager } from '../../util/gridStackUtils';

import './Reports.scss';
import _ from 'lodash';
import { formatWorkDuration } from '../../util/dates';

function formatCycletimeLabel(point, excludeWeekendOpts, timePrecision) {
  const duration = formatWorkDuration(point.y, excludeWeekendOpts, timePrecision);
  return `(${duration}) ${(point.percentage || 0).toFixed(2)}%`;
}

function formatThroughputLabel(point) {
  return `${(point.percentage || 0).toFixed(2)}% (${point.y} ${point.y > 1 ? 'items' : 'item'})`;
}

const DragIcon = ({ customizeMode }) => (
  <div className={`card-drag ${customizeMode ? '' : 'hidden'}`}>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M15.9454 17.8918C16.3087 17.8918 16.5938 18.1771 16.5939 18.5403V21.7844H18.9298C19.5004 21.7847 19.7859 22.4848 19.3839 22.887L14.4659 27.804C14.2065 28.0634 13.8045 28.0634 13.545 27.804L8.62805 22.887C8.21287 22.4848 8.49831 21.7844 9.08215 21.7844H11.4044V18.5403C11.4045 18.1772 11.6897 17.892 12.0529 17.8918H15.9454ZM5.11145 8.62817C5.51365 8.21299 6.21497 8.49842 6.21497 9.08228V11.4045H9.45813C9.82136 11.4045 10.1065 11.6898 10.1066 12.053V15.9456C10.1065 16.3088 9.82139 16.594 9.45813 16.594H6.21497V18.9163C6.21497 19.5001 5.11365 19.7862 5.11145 19.384L0.194458 14.4661C-0.0647671 14.2066 -0.0648822 13.8046 0.194458 13.5452L5.11145 8.62817ZM21.7843 9.08228C21.7843 8.49842 22.4844 8.21299 22.8995 8.62817L27.8165 13.5452C28.063 13.7917 28.0633 14.2069 27.8038 14.4534L22.8868 19.3704C22.4846 19.7855 21.7843 19.5001 21.7843 18.9163V16.594H18.5402C18.177 16.5939 17.8918 16.3088 17.8917 15.9456V12.053C17.8918 11.6898 18.177 11.4046 18.5402 11.4045H21.7843V9.08228ZM13.5323 0.19458C13.7918 -0.064883 14.1938 -0.0649015 14.4532 0.19458L19.3702 5.11157C19.7854 5.51378 19.5 6.21509 18.9161 6.21509H16.5939V9.45825C16.5939 9.82152 16.3087 10.1067 15.9454 10.1067H12.0529C11.6897 10.1066 11.4044 9.82147 11.4044 9.45825V6.21509H9.08215C8.49831 6.21509 8.21315 5.51378 8.61536 5.11157L13.5323 0.19458Z" fill="#004080"/>
    </svg>
  </div>
);

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.gridRef = React.createRef();
    this.gridManager = null;
    this.state = {
      comparison: false,
      percentile: (props.filters && props.filters.percentile) || 85,
      threshold: (props.filters && props.filters.threshold) || 5,
      dateRange: props.dateRange || 'lastMonth',
      dateFormat: (props.filters && props.filters.dateFormat) || 'D/MM/YY',
      isFullScreen: '',
      cycletime: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      throughput: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      wip: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      wat: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      page: 1,
      th: false,
      wp: false,
      wat: false,
      ct: false,
      fe: false
    };
  }

  componentDidMount() {
    const isComparisonInitially = this.props.location.search && this.props.location.search.includes('comparison=true');
    const currentReportId = this.props.routeParams.id || this.props.selectedStream && this.props.selectedStream._id;

    this.setState({ comparison: isComparisonInitially });

    if (!this.trialExpired()) {
      if (isComparisonInitially) {
        if (currentReportId) {
          this.props.getFilters(currentReportId);
        }
      } else {
        if (currentReportId) {
          this.props.getFilters(currentReportId);
        }
      }
    }

    if (!isComparisonInitially) {
      this.initializeGridStack();
    }
  }

  async initializeGridStack() {
    if (!this.gridRef.current) return;

    this.gridManager = new GridStackManager(this.gridRef, {
      cellHeight: 350,
      column: 12
    });

    await this.gridManager.loadGridStack();

    if (this.gridManager) {
      this.gridManager.triggerChartResize();
    }
  }

  componentWillUnmount() {
    if (this.gridManager) {
      this.gridManager.destroy();
      this.gridManager = null;
    }
  }

componentDidUpdate(prevProps, prevState) {
  const prevStreamId = prevProps.selectedStream ? prevProps.selectedStream._id : undefined;
  const currentStreamId = this.props.selectedStream ? this.props.selectedStream._id : undefined;
  const currentReportContextId = this.props.routeParams.id || currentStreamId;
  const prevReportContextId = prevProps.routeParams.id || prevStreamId;
  const reportContextIdChanged = currentReportContextId !== prevReportContextId;

    const filtersChanged = !_.isEqual(prevProps.filters, this.props.filters);
    const locationSearchChanged = prevProps.location.search !== this.props.location.search;

    if (filtersChanged && this.props.filters) {
      const stateUpdates = {};
      if (this.props.filters.percentile !== undefined && this.props.filters.percentile !== this.state.percentile) {
        stateUpdates.percentile = this.props.filters.percentile;
      }
      if (this.props.filters.threshold !== undefined && this.props.filters.threshold !== this.state.threshold) {
        stateUpdates.threshold = this.props.filters.threshold;
      }
      if (Object.keys(stateUpdates).length > 0) {
        this.setState(stateUpdates);
      }
    }

    if (this.props.routeParams.id && !this.props.loading && _.findIndex(this.props.streams, { _id: this.props.routeParams.id }) === -1){
      this.props.router.push('/no-value-stream-permissions');
    }
    if (reportContextIdChanged && currentReportContextId) {
      this.props.getFilters(currentReportContextId);
    }

    if (locationSearchChanged) {
      const newIsComparisonFromUrl = this.props.location.search && this.props.location.search.includes('comparison=true');
      if (newIsComparisonFromUrl !== this.state.comparison) {
        if (newIsComparisonFromUrl && this.gridManager) {
          this.gridManager.cleanupWithoutDom();
          this.gridManager = null;
        }
        this.setState({ comparison: newIsComparisonFromUrl }, () => {
          if (this.state.comparison) {
            this.getComparsion(currentStreamId);
          } else {
            if (currentReportContextId) this.props.requestData(currentReportContextId);
            this._syncBreakdownSettingsFromProps(this.props, prevProps);
            this.initializeGridStack();
          }
        });
      }
    }

  if (filtersChanged && this.props.filters && this.props.filters.name && !this.props.loading) {
    const statsUpdatedWithFilters = !_.isEqual(prevProps.stats, this.props.stats);
    if (!this.state.comparison) {
      const loaded = this._syncBreakdownSettingsFromProps(this.props, prevProps);
      if (currentReportContextId && !loaded && !statsUpdatedWithFilters) {
        this.props.requestData(currentReportContextId);
      }
    } else {
      this.getComparsion(currentStreamId);
    }
    }
    else if (reportContextIdChanged && this.props.filters && this.props.filters.name && !this.state.comparison) {
      this._syncBreakdownSettingsFromProps(this.props, prevProps);
    }
  }

  getBreakDownName(values) {
    const { filters } = this.props;
    let name;

    if (values.indexOf('labels') > -1) {
      switch (this.props.app) {
        case 'azure':
          return 'Work item types';
        case 'trello':
          return 'Labels';
        case 'asana':
          return 'Tags';
        case 'jira':
          return 'Priorities';
      }
    }

    if (values.indexOf('statuses') > -1) {
      switch (this.props.app) {
        case 'jira':
        case 'file':
          return 'Statuses';
        case 'azure':
          return 'Columns';
        case 'trello':
          return 'Lists';
        case 'asana':
          return 'Sections';
      }
    }

    _.some(values, value => {
      return _.some(filters.dashboards, dashboard => {
        const cf = _.find(dashboard.allCustomFields, { id: value });
        if (cf) {
          name = cf.name;
          return true;
        }
      });
    });
    return name;
  };


  updateFontSize = chart => {};

 getReport = (newDashboardFilters = this.props.filters.dashboards, triggerDataRefresh = true, updateFilters = false) => {
    const { threshold, percentile } = this.state;
    const { wallmode, selectedStream, routeParams, setFilters, requestData } = this.props;
    const currentReportId = selectedStream && selectedStream._id || routeParams.id;

    if (!currentReportId) {
      return;
    }

    const bodyForSetFilters = {
      dashboards: newDashboardFilters,
      controls: { threshold, percentile }
    };

    if (!wallmode && selectedStream && updateFilters) {
      setFilters(currentReportId, bodyForSetFilters, true).then((result) => {
        if (this.state.comparison) {
          this.getComparsion(currentReportId);
        } else if (result && !result.hasData && !result.error) {
          requestData(currentReportId);
        }
      });
    } else if (triggerDataRefresh && !this.state.comparison) {
      requestData(currentReportId);
    }
  };

  applyFilters = (filters = {}, isInitial) => {
    this.getReport(filters, true, true);

    if(!isInitial){
      trackExecutiveFilterChange(this.getDashboardsNames(), 'filters');
    }
  }

  handleDateChange = dates => {
    const body = {
      dates: {
        startDate: dates.startDate.toISOString(),
        endDate: dates.endDate.toISOString(),
        customDate: dates.customDate,
        fixedStartDate: dates.fixedStartDate,
        dateDiff: dates.daysFromStart
      }
    };

    this.props.setFilters(this.props.selected._id, body, true).then((result) => {
      if (result && !result.hasData && !result.error) {
        this.props.requestData(this.props.selected._id);
      }
    });

    trackExecutiveFilterChange(this.getDashboardsNames(), 'period', body.dates);
  };

  handleConfigure = () => {
    this.props.router.push('/configure/'+  this.props.selected._id);
  };

  handleNew = () => {
    this.props.select({ isNew: true });
    this.props.router.push('/configure');
  };

  handlePdfExport = () => {
    if (this.state.comparison) {
      const { percentile, threshold } = this.state;
      this.props.getComparisonPdf(percentile, threshold, this.props.selected && this.props.selected._id);
      return;
    }
    this.props.getPdf(this.props.selected && this.props.selected._id);
  };

  handleCsvExport = () => {
    this.props.getCsv(this.props.selected && this.props.selected._id);
  }

  getComparsion = (currentStreamId) => {
    const { page } = this.state;
    this.props.requestComparisonData(page, currentStreamId);
  };

  changePercentile = value => {
    this.setState({ percentile: parseInt(value, 10) });

    trackReportConfigChange(this.getDashboardsNames(), 'ct_percentile', { percent: parseInt(value, 10) } );
  };

  changeThreshold = value => {
    this.setState({ threshold: value });

    trackReportConfigChange(this.getDashboardsNames(),'controls', { variation: value } );
  };

  changeDateRange = value => {
    this.setState({ dateRange: value });
    this.props.saveSelectedDateRange(this.props.selected._id, value);

    trackReportConfigChange(this.getDashboardsNames(), 'controls', { group_by: this.getGroupByValue(value) } );
  };

  getGroupByValue(value) {
    switch(value) {
      case 'lastWeek':
        return 'one_week';
      case 'last2Week':
        return 'two_weeks';
      case 'lastMonth':
        return 'month';
      case 'last3Month':
        return 'quarter';
      default:
        return value;
    }
  }

  getDashboardsNames() {
    return this.props.filters && this.props.filters.dashboards ?
      _.join(_.map(this.props.filters.dashboards, 'name')) : '';
  }

  toggleView = (comparison) => {
    if (!this.props.loading && (comparison !== this.state.comparison)){
      this.setState({ comparison });
      if (comparison) {
        this.getComparsion(this.props.routeParams.id);
      } else {
        this.props.requestData(this.props.routeParams.id);
      }
    }
  };

  compare(current, previous) {
    return Math.round((10000 * current) / previous) / 100 - 100;
  }

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getComparsion);
  };

  onBreakdownChange = (widget, field) => {
    const { selectedStream, saveSelectedBreakdown, wallmode } = this.props;
    const reportId = selectedStream && selectedStream._id;
    if (!reportId) {
      return;
    }
    if (!wallmode){
      saveSelectedBreakdown(reportId, widget, field.id);
    }
    trackExecutiveFilterChange(this.getDashboardsNames(), `${widget}_breakdown_by`, {
      breakdown_by: field.id === null ? '' : field.name
    });
  }

  handleChartExpand = (stateKey, cardId, trackingId) => {
    const newValue = !this.state[stateKey];
    this.setState({ [stateKey]: newValue }, () => {
      if (this.gridManager) {
        const card = document.getElementById(cardId);
        if (card) {
          this.gridManager.updateWidgetHeight(card, newValue ? 2 : 1);
        }
      }
      this.trackChartDetailsView(trackingId, !newValue);
    });
  };

  handleResize = ev => {
    const chart = ev.target.id.split('-')[1];
    if (this.state.isFullScreen) {
      this.setState(
        { isFullScreen: '' },
        () => this.updateFontSize(chart)
      );
    } else {
      this.setState(
        { isFullScreen: chart },
        () => this.updateFontSize(chart)
      );

      trackExecutiveDashboardView(chart);
    }
  };

  trackChartDetailsView (chart, isHidden) {
    if (!isHidden) {
      trackExecutiveDashboardView(chart + '_details');
    }
  }

  fillComparisonValues = (getValue, threshold) => {
    const currentMonthValue = getValue(0);
    const values = [];
    values.push({ value: currentMonthValue });
    for (let j = 1; j < 4; j++) {
      if (currentMonthValue) {
        const cValue = getValue(j);
        const cComparison = this.compare(currentMonthValue, cValue);
        values.push({
          value: cValue,
          comparison: cComparison,
          active: Math.abs(cComparison) > threshold
        });
      } else {
        values.push({});
      }
    }
    return values;
  };

  convertReportDataItemToComparisonValues = (percentile, threshold, d, dashboard) => {
    const item = {
      name: dashboard.name,
      month: d.month,
      avgCycleTime: this.fillComparisonValues(
        i => _.find(d.comparison[i].cycleTime, { name: percentile }).value,
        threshold
      ),
      avgThroughput: this.fillComparisonValues(i => d.comparison[i].throughput, threshold),
      wipTrend: this.fillComparisonValues(i => d.comparison[i].wipTrend, threshold),
      wipAge: this.fillComparisonValues(i => d.comparison[i].wipAge, threshold),
      flowEfficiency: this.fillComparisonValues(i => d.comparison[i].flowEfficiency, threshold)
    };

    return item;
  };
_deriveBreakdownStateForWidget(widgetType, currentProps = this.props) {
    const { filters } = currentProps;
    const breakdownList = getBreakDownList(filters && filters.dashboards, widgetType);

    let defaultName = '';
    let defaultValue = [];

    if (breakdownList && breakdownList.length > 0) {
      defaultName = breakdownList[0].name;
      defaultValue = breakdownList[0].id;
    } else {
      return {
        ...this.state[widgetType],
        name: '', search: '', value: [],
      };
    }

    const selectedBreakdownIdsFromFilters = filters && filters[widgetType];
    let derivedName = defaultName;
    let derivedValue = defaultValue;

    if (selectedBreakdownIdsFromFilters && Array.isArray(selectedBreakdownIdsFromFilters) && selectedBreakdownIdsFromFilters.length > 0) {
      const nameFromFilterIds = this.getBreakDownName(selectedBreakdownIdsFromFilters);
      if (nameFromFilterIds) {
        const foundInList = breakdownList.find(item => item.name === nameFromFilterIds);
        if (foundInList) {
          derivedName = foundInList.name;
          derivedValue = foundInList.id;
        }
      }
    }

    return {
      ...this.state[widgetType],
      name: derivedName,
      search: derivedName,
      value: derivedValue,
    };
  }

 _syncBreakdownSettingsFromProps(propsToUse = this.props, prevProps = {}) {
    const { filters, selectedStream, routeParams, stats } = propsToUse;
    const currentReportId = selectedStream && selectedStream._id || routeParams.id;

    if (!filters || !filters.name || !currentReportId) {
        return false;
    }

    const newCycleTimeState = this._deriveBreakdownStateForWidget('cycletime', propsToUse);
    const newThroughputState = this._deriveBreakdownStateForWidget('throughput', propsToUse);

    const stateToUpdate = {};
    let needsUiUpdateForBreakdownSelection = false;

    if (!_.isEqual(this.state.cycletime.name, newCycleTimeState.name) || !_.isEqual(this.state.cycletime.value, newCycleTimeState.value)) {
      stateToUpdate.cycletime = { ...this.state.cycletime, ...newCycleTimeState };
      needsUiUpdateForBreakdownSelection = true;
    }
    if (!_.isEqual(this.state.throughput.name, newThroughputState.name) || !_.isEqual(this.state.throughput.value, newThroughputState.value)) {
      stateToUpdate.throughput = { ...this.state.throughput, ...newThroughputState };
      needsUiUpdateForBreakdownSelection = true;
    }

    let criticalFiltersChanged = false;
    if (prevProps.filters) {
        const relevantCurrentFilters = {
            dashboards: filters.dashboards,
            controls: filters.controls,
            name: filters.name
        };
        const relevantPrevFilters = {
            dashboards: prevProps.filters.dashboards,
            controls: prevProps.filters.controls,
            name: prevProps.filters.name
        };
        function preprocessFilters(filters) {
          const clonedFilters = _.cloneDeep(filters); // Use Lodash's cloneDeep
          if (clonedFilters.dashboards && Array.isArray(clonedFilters.dashboards)) {
            clonedFilters.dashboards.forEach(dashboard => {
              if (dashboard.allMembers && Array.isArray(dashboard.allMembers)) {
                dashboard.allMembers.forEach(member => {
                  if (member && member._id === 'no-member' && member.value === 'no-member') {
                    delete member.label;
                  }
                });
              }
            });
          }
          return clonedFilters;
        }

        const processedCurrentFilters = preprocessFilters(relevantCurrentFilters);
        const processedPrevFilters = preprocessFilters(relevantPrevFilters);
        if (!_.isEqual(processedCurrentFilters, processedPrevFilters)) {
            criticalFiltersChanged = true;
        }
    } else {
        criticalFiltersChanged = true;
    }

    const statsUpdatedWithFilters = prevProps.stats && !_.isEqual(prevProps.stats, stats);
    let willRefreshData = false;

    if (needsUiUpdateForBreakdownSelection) {
      if (criticalFiltersChanged && !statsUpdatedWithFilters) {
        willRefreshData = true;
        this.setState(stateToUpdate, () => {
          if (!this.state.comparison) {
            this.getReport(filters.dashboards, true);
          }
        });
      } else {
        this.setState(stateToUpdate);
      }
    } else if (!this.state.comparison && criticalFiltersChanged && !statsUpdatedWithFilters) {
      willRefreshData = true;
      this.getReport(filters.dashboards, true);
    }

    return willRefreshData;
}

deleteStream() {
  this.props.remove(this.props.selected._id);
  if (this.state.comparison) {
    this.props.router.push('/report?comparison=true');
  } else {
    this.props.router.push('/report');
  }
}

  renderComparisonReport() {
    const { percentile, threshold, dateRange } = this.state;
    const { comparisons, wallmode } = this.props;
    const comparison = comparisons && comparisons[dateRange] && comparisons[dateRange].data;
    const comparisonDates = comparisons && comparisons[dateRange] && comparisons[dateRange].dates;
    let result = [];
    _.forEach(comparison, dashboard => {
      _.forEach(dashboard.data, (d, i) => {
        let item = this.convertReportDataItemToComparisonValues(percentile, threshold, d, dashboard);
        result.push(item);
      });
    });

    result = _.groupBy(result, 'month');
    return (
      <div className='report execdashboard comparison'>
        <NoData show={!result && !this.props.loading} />
        {this.props.loading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}
        {!wallmode && (<div className='button_tools tracking'>
          <Link className="btn btn-secondary btn-md" to={`/report/${this.props.selected._id}`}>
            Value Stream Dashboard
          </Link>
        </div>)}
        {result && comparisonDates && (
          <React.Fragment>
            <ReportTable
              key="avgCycleTimeReportTable"
              percentile={this.state.percentile}
              changePercentile={this.changePercentile}
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Cycle Time"
              fieldName="avgCycleTime"
              positive={true}
              time={true}
              excludeWeekendOpts={this.props.excludeWeekendOpts}
            ></ReportTable>
            <ReportTable
              key="avgThroughputReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Average Throughput"
              fieldName="avgThroughput"
              positive={false}
            ></ReportTable>
            <ReportTable
              key="wipTrendReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Average WIP"
              fieldName="wipTrend"
              positive={true}
            ></ReportTable>
            <ReportTable
              key="awipAgeReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Average WIP Age"
              fieldName="wipAge"
              positive={true}
              time={true}
              excludeWeekendOpts={this.props.excludeWeekendOpts}
            ></ReportTable>
            <ReportTable
              key="flowEfficiencyReportTable"
              data={result}
              dates={comparisonDates}
              dateFormat={this.state.dateFormat}
              columnHeader="Flow Efficiency"
              fieldName="flowEfficiency"
              positive={false}
            ></ReportTable>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderPercentiles() {
    return (
      <div className='report-info-box'>
        {this.props.stats.avgPercentiles &&
          this.props.stats.avgPercentiles.map((p, i) => {
            return (
              <div key={i}>
                <h4>
                  {formatWorkDuration(p.value, this.props.excludeWeekendOpts, 'd[d] h[h] m[m]')}
                </h4>
                <p>{p.text}th percentile</p>
              </div>
            );
          })}
      </div>
    );
  }
  renderButtons() {
    const { user, selected, loading } = this.props;
    const access = getStreamAccessRights(user, selected);
    const canCreateStreams = user && user.permissions && user.permissions.createStreams;

    return [
      <SubscribeEDAddOn key="subscribe" />,
      canCreateStreams && <DropdownButton
        key="create-dropdown"
        id="create-dropdown"
        variant='secondary'
        size='sm'
        title={
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="tooltip-create-stream" className='tooltip_dark'>Create Value Stream</Tooltip>}
          >
            <img src={createIcon} alt="" />
          </OverlayTrigger>
        }
        >
        <li>
          <Button onClick={this.handleNew} className='btn'>
            <span className="title"><img src={createIcon} alt="#"/> Create Value Stream</span>
            <span className="help-text">
              Select the team dashboards you'd like to include to build a value stream and visualize your end-to-end delivery flow.
            </span>
          </Button>
        </li>
      </DropdownButton>,
      
      selected && (
        <DropdownButton
          disabled = {loading}
          key="stream-settings"
          id="stream-settings"
          size='sm'
          variant='secondary'
          title={
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-settings" className='tooltip_dark'>
                  Value Stream Settings
                </Tooltip>
              }
            >
              <img src={settingsIcon} alt="" />
            </OverlayTrigger>
          }
        >
          {this.state.comparison ? (
            <li key="pdf-export">
              <Button onClick={this.handlePdfExport}>
                <span className="title">
                  <img src={exportIcon} alt="Export"/> Export PDF Report
                </span>
                <span className="help-text">
                  Generate a PDF report of your dashboard for easy sharing and presentation.
                </span>
              </Button>
            </li>
          ) : (
            <React.Fragment>
              <li key="csv-export">
                <Button onClick={this.handleCsvExport}>
                  <span className="title">
                    <img src={cloudDownload} alt="Export"/> Export Dashboard Data
                  </span>
                  <span className="help-text">
                    Export your dashboard data as a CSV file to create custom reports.
                  </span>
                </Button>
              </li>
              <li key="pdf-export">
                <Button onClick={this.handlePdfExport}>
                  <span className="title">
                    <img src={exportIcon} alt="Export"/> Export PDF Report
                  </span>
                  <span className="help-text">
                    Generate a PDF report of your dashboard for easy sharing and presentation.
                  </span>
                </Button>
              </li>
            </React.Fragment>
          )}

          {!!access.edit && <li key="edit-stream" onClick={ev => this.handleConfigure(selected)}>
            <div className='btn'>
              <span className="title">
                <img src={editIcon} alt="Edit" /> Edit Value Stream
              </span>
              <span className="help-text">
                Add or remove dashboards connected to this value stream and update your data.
              </span>
            </div>
          </li>}

          {!!access.delete && <li key="delete-stream">
            <Confirm
              onConfirm={ev => this.deleteStream()}
              body={
                <p>
                  Are you sure you want to delete <strong>{selected.name}</strong>?
                </p>
              }
              confirmText="Delete"
              icon={deleteIcon}
              title="Delete value stream"
            >
              <div className='btn'>
                <span className="title red">
                  <img src={deleteIcon} alt="Delete" /> Delete Value Stream
                </span>
                <span className="help-text">
                  Permanently delete the value stream and all associated dashboard data.
                  This action cannot be undone.
                </span>
              </div>
            </Confirm>
          </li>}
        </DropdownButton>
      ),

      selected && (
        <DropdownButton
          disabled = {loading}
          key="views-actions"
          id="views-dropdown"
          size='sm'
          variant='secondary'
          title={<img src={dashboardIcon} alt="Dashboard actions" />}
        >
          {!!access.view && (
            <li key="apply-view">
              <Views>
                <Button>
                  Apply value stream view
                  <span className="help-text">
                    Apply the set of controls and filters previously stored on this value stream
                  </span>
                </Button>
              </Views>
            </li>
          )}
          {!!access.edit && (
            <li key="save-view">
              <SaveView>
                <Button>
                  Save current value stream view
                  <span className="help-text">
                    Store the current set of controls and filters on this value stream
                  </span>
                </Button>
              </SaveView>
            </li>
          )}
        </DropdownButton>
      )
    ];
  }

  renderExecutiveReport() {
    const flowEfficiency = !isNaN(this.props.stats.avgFe);
    const { wallmode, filters } = this.props;
    const {
      isFullScreen,
      wp,
      th,
      wat,
      ct,
      fe,
    } = this.state;

    const breakDownItemsCt = getBreakDownList(filters && filters.dashboards, 'cycletime');
    const breakDownItemsTh = getBreakDownList(filters && filters.dashboards, 'throughput');
    const subsetColors = _(this.props.trends && this.props.trends.throughput)
      .map(({ name, color }) => [name, color])
      .fromPairs()
      .value();


    const reportUrl = this.props.selected && this.props.selected._id ? `/report/${this.props.selected._id}?comparison=true` : '/report?comparison=true';
    return (
      <div className='report-wrap execdashboard'>
        {!wallmode && (<div className='button_tools tracking'>
          <Link className="btn btn-secondary btn-md" to={reportUrl}>
            Value Stream Report
          </Link>
          <DatePicker updateValue={wallmode ? null : this.handleDateChange} disableSave />
        </div>)}

        {this.props.loading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}


        {/*<NoData show={!this.props.trends.avgCt} />*/}

        <div ref={this.gridRef} className="grid-stack row-cell-list">
          <div className="grid-stack-item" gs-w="4" id="card-cycletime">
            <div className="widget">
              <PieChartWidget
                className="cell cell-33"
                name="cycletime-breakdown"
                title={
                  <React.Fragment>
                    Avg. Cycle Time <span>{formatWorkDuration(this.props.stats.avgCt, this.props.excludeWeekendOpts, 'd[d] h[h] m[m]')}</span>
                    <DragIcon customizeMode={this.props.customizeMode} />
                  </React.Fragment>
                }
                formatter={(p) => formatCycletimeLabel(p, this.props.excludeWeekendOpts, this.props.filters.timePrecision)}
                breakdowns={this.props.stats.cycletimeBreakdowns}
                options={breakDownItemsCt}
                colors={subsetColors}
                selected={this.props.filters && this.props.filters.cycletime && this.props.filters.cycletime[0] || (breakDownItemsCt.length > 0 ? breakDownItemsCt[0].id[0] : '')}
                onResize={() => trackExecutiveDashboardView('cycletime-breakdown')}
                onSelect={(field) => this.onBreakdownChange('cycletime', field)}
              />
            </div>
          </div>

          <div className="grid-stack-item" gs-w="4" id="card-throughput">
            <div className="widget">
                <PieChartWidget
                  className="cell cell-33"
                  name="throughput-breakdown"
                  title={
                    <React.Fragment>
                      Throughput <span>{this.props.stats.avgThroughput} work items</span>
                      <DragIcon customizeMode={this.props.customizeMode} />
                    </React.Fragment>
                  }
                formatter={(p) => formatThroughputLabel(p)}
                breakdowns={this.props.stats.throughputBreakdowns}
                options={breakDownItemsTh}
                colors={subsetColors}
                selected={this.props.filters && this.props.filters.throughput && this.props.filters.throughput[0] || (breakDownItemsTh.length > 0 ? breakDownItemsTh[0].id[0] : '')}
                onResize={() => trackExecutiveDashboardView('throughput-breakdown')}
                onSelect={(field) => this.onBreakdownChange('throughput', field)}
              />
            </div>
          </div>

          <div className='grid-stack-item' gs-w="4" id="card-percentiles">
            <div className='average cell-33'>
              {flowEfficiency && (
                <div className='cell cell-height-auto'>
                  <div className='cell-header'>
                    <h4>Avg. Flow Efficiency <span>{this.props.stats.avgFe}%</span></h4>
                    <DragIcon customizeMode={this.props.customizeMode} />
                  </div>
                </div>
              )}
              <div className='cell cell-height-full'>
                <div className='cell-header'>
                  <h4>Avg. Cycle Time Percentiles</h4>
                </div>
                <div className="cell-content">
                  {this.renderPercentiles()}
                </div>
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${wp ? 2 : 1}`} style={isFullScreen === 'wip' ? { zIndex: 9999 } : wp ? {height: 'calc(2 * var(--gs-cell-height))' } : {}} id="card-wip">
            <div className={`cell ${ isFullScreen === 'wip' ? 'fullscreen' : '' } ${ wp ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>WIP Trends</h4>
                <Button variant="flat" size="md" onClick={() => this.handleChartExpand('wp', 'card-wip', 'wip')}>
                  <img src={wp ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-wip" onClick={this.handleResize}>
                  <img src={isFullScreen === 'wip' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  id="wip"
                  className="chart"
                  detailed={wp}
                  isFullScreen={isFullScreen === 'wip'}
                  showExactDate={true}
                  plural={false}
                  tooltipLabel="Work items"
                  unit="item"
                  data={this.props.trends.wip}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${th ? 2 : 1}`} style={isFullScreen === 'tht' ? { zIndex: 9999 } : th ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-throughput-trends">
            <div className={`cell ${isFullScreen === 'tht' ? 'fullscreen' : '' } ${ th ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Throughput Trends</h4>
                <Button variant="flat" size="md" onClick={() => this.handleChartExpand('th', 'card-throughput-trends', 'tht')}>
                  <img src={th ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-tht" onClick={this.handleResize}>
                  <img src={isFullScreen === 'tht' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>
              <div className='cell-content'>
                <LineChart
                  id="throughput"
                  className="chart"
                  detailed={th}
                  isFullScreen={isFullScreen === 'tht'}
                  plural={true}
                  tooltipLabel="Work items"
                  unit="item"
                  data={this.props.trends.throughput}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${wat ? 2 : 1}`} style={isFullScreen === 'wat' ? { zIndex: 9999 } : wat ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-wipAge">
            <div className={`cell ${isFullScreen === 'wat' ? 'fullscreen' : '' } ${ wat ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>WIP Age Trends</h4>
                <Button variant="flat" size="md" onClick={() => this.handleChartExpand('wat', 'card-wipAge', 'wat')}>
                  <img src={wat ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-wat" onClick={this.handleResize}>
                  <img src={isFullScreen === 'wat' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>
              <div className='cell-content'>
                <LineChart
                  id="wat"
                  className="chart"
                  detailed={wat}
                  showExactDate={true}
                  isFullScreen={isFullScreen === 'wat'}
                  tooltipLabel="Avg. WIP Age Time"
                  unit="day"
                  data={this.props.trends.avgWat}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${ct ? 2 : 1}`} style={isFullScreen === 'ctt' ? { zIndex: 9999 } : ct ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-ctb">
            <div className={`cell ${isFullScreen === 'ctt' ? 'fullscreen' : ''} ${ ct ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Cycle Time Trends</h4>
                <Button variant='flat' size="md" onClick={() => this.handleChartExpand('ct', 'card-ctb', 'ctt')}>
                  <img src={ct ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant='flat' size="md" id="fullscreen-ctt" onClick={this.handleResize}>
                  <img src={isFullScreen === 'ctt' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>
              <div className='cell-content'>
                <LineChart
                  id="ct"
                  className="chart"
                  detailed={ct}
                  isFullScreen={isFullScreen === 'ctt'}
                  tooltipLabel="Avg. Cycle Time"
                  unit="day"
                  data={this.props.trends.avgCt}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" id="card-percentile-trends">
            <div className={`cell ${isFullScreen === 'percentile' ? 'fullscreen' : '' }`}>
              <div className='cell-header'>
                <h4>Percentile Trends</h4>
                <Button variant='flat' size="md" id="fullscreen-percentile" onClick={this.handleResize}>
                  <img src={isFullScreen === 'percentile' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <div className={`card-drag ${this.props.customizeMode ? '' : 'hidden'}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M15.9454 17.8918C16.3087 17.8918 16.5938 18.1771 16.5939 18.5403V21.7844H18.9298C19.5004 21.7847 19.7859 22.4848 19.3839 22.887L14.4659 27.804C14.2065 28.0634 13.8045 28.0634 13.545 27.804L8.62805 22.887C8.21287 22.4848 8.49831 21.7844 9.08215 21.7844H11.4044V18.5403C11.4045 18.1772 11.6897 17.892 12.0529 17.8918H15.9454ZM5.11145 8.62817C5.51365 8.21299 6.21497 8.49842 6.21497 9.08228V11.4045H9.45813C9.82136 11.4045 10.1065 11.6898 10.1066 12.053V15.9456C10.1065 16.3088 9.82139 16.594 9.45813 16.594H6.21497V18.9163C6.21497 19.5001 5.51365 19.7862 5.11145 19.384L0.194458 14.4661C-0.0647671 14.2066 -0.0648822 13.8046 0.194458 13.5452L5.11145 8.62817ZM21.7843 9.08228C21.7843 8.49842 22.4844 8.21299 22.8995 8.62817L27.8165 13.5452C28.063 13.7917 28.0633 14.2069 27.8038 14.4534L22.8868 19.3704C22.4846 19.7855 21.7843 19.5001 21.7843 18.9163V16.594H18.5402C18.177 16.5939 17.8918 16.3088 17.8917 15.9456V12.053C17.8918 11.6898 18.177 11.4046 18.5402 11.4045H21.7843V9.08228ZM13.5323 0.19458C13.7918 -0.064883 14.1938 -0.0649015 14.4532 0.19458L19.3702 5.11157C19.7854 5.51378 19.5 6.21509 18.9161 6.21509H16.5939V9.45825C16.5939 9.82152 16.3087 10.1067 15.9454 10.1067H12.0529C11.6897 10.1066 11.4044 9.82147 11.4044 9.45825V6.21509H9.08215C8.49831 6.21509 8.21315 5.51378 8.61536 5.11157L13.5323 0.19458Z" fill="#004080"/>
                  </svg>
                </div>
              </div>
              <div className='cell-content'>
                <LineChart
                  id="percentiles-trend"
                  className="chart"
                  isFullScreen={isFullScreen === 'percentile'}
                  tooltipLabel=""
                  unit=""
                  showLegend={isFullScreen === 'percentile'}
                  legendSuffix="%"
                  data={this.props.trends.percentiles}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${fe ? 2 : 1}`} style={isFullScreen === 'fe' ? { zIndex: 9999 } : fe ? { height: 'calc(2 * var(--gs-cell-height))' } : {}} id="card-flow-efficiency">
            <div className={`cell ${isFullScreen === 'fe' ? 'fullscreen' : ''} ${ fe ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Flow Efficiency Trends</h4>
                <Button variant="flat" size="md" onClick={() => this.handleChartExpand('fe', 'card-flow-efficiency', 'fe')}>
                  <img src={fe ? lineChartOnIcon : lineChartOffIcon} alt="toggleFullScreen" />
                </Button>
                <Button variant="flat" size="md" id="fullscreen-fe" onClick={this.handleResize}>
                  <img src={isFullScreen === 'fe' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <div className={`card-drag ${this.props.customizeMode ? '' : 'hidden'}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path d="M15.9454 17.8918C16.3087 17.8918 16.5938 18.1771 16.5939 18.5403V21.7844H18.9298C19.5004 21.7847 19.7859 22.4848 19.3839 22.887L14.4659 27.804C14.2065 28.0634 13.8045 28.0634 13.545 27.804L8.62805 22.887C8.21287 22.4848 8.49831 21.7844 9.08215 21.7844H11.4044V18.5403C11.4045 18.1772 11.6897 17.892 12.0529 17.8918H15.9454ZM5.11145 8.62817C5.51365 8.21299 6.21497 8.49842 6.21497 9.08228V11.4045H9.45813C9.82136 11.4045 10.1065 11.6898 10.1066 12.053V15.9456C10.1065 16.3088 9.82139 16.594 9.45813 16.594H6.21497V18.9163C6.21497 19.5001 5.51365 19.7862 5.11145 19.384L0.194458 14.4661C-0.0647671 14.2066 -0.0648822 13.8046 0.194458 13.5452L5.11145 8.62817ZM21.7843 9.08228C21.7843 8.49842 22.4844 8.21299 22.8995 8.62817L27.8165 13.5452C28.063 13.7917 28.0633 14.2069 27.8038 14.4534L22.8868 19.3704C22.4846 19.7855 21.7843 19.5001 21.7843 18.9163V16.594H18.5402C18.177 16.5939 17.8918 16.3088 17.8917 15.9456V12.053C17.8918 11.6898 18.177 11.4046 18.5402 11.4045H21.7843V9.08228ZM13.5323 0.19458C13.7918 -0.064883 14.1938 -0.0649015 14.4532 0.19458L19.3702 5.11157C19.7854 5.51378 19.5 6.21509 18.9161 6.21509H16.5939V9.45825C16.5939 9.82152 16.3087 10.1067 15.9454 10.1067H12.0529C11.6897 10.1066 11.4044 9.82147 11.4044 9.45825V6.21509H9.08215C8.49831 6.21509 8.21315 5.51378 8.61536 5.11157L13.5323 0.19458Z" fill="#004080"/>
                  </svg>
                </div>
              </div>
              <div className='cell-content'>
                <LineChart
                  id="fe"
                  className="chart"
                  detailed={fe}
                  isFullScreen={isFullScreen === 'fe'}
                  tooltipLabel="Avg. Flow Efficiency"
                  unit="%"
                  data={this.props.trends.flowEfficiency}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  trialExpired(){
    return !this.props.user.config || moment(this.props.user.config.exportTrialEnd).diff(moment()) < 0 || !this.props.user.config.exportEnabled;
  }

  render() {
    const { wallmode, filters, dateRange, user, selected } = this.props;
    const trialExpired = this.trialExpired();
    const access = getStreamAccessRights(user, selected);
    return [
      !trialExpired && <ValueStreamSelector key="1" title="" buttons={wallmode ? null : this.renderButtons()} showTeam={true}
        items={this.props.streams}
        selectedItem={this.props.selectedStream}
        onSelect={this.props.selectStream}
        onSaveSelected={this.props.saveSelectedStream}
        onListAll={this.props.listAllStreams}
        loaded = {this.props.loaded}
        noItems={this.props.noStreams}
        basePath="/report"
        emptyPath="/no-streams"
        searchPlaceholder="Search Value Stream"
        defaultItemImage={defaultBoardImg}
        defaultItemIdFromUserConfigKey="selectedValueStream"
        dataIsLoading={this.props.loading}
        showTeamInHeader={true}
      />,
      !trialExpired && <div key="2" id="executive" className='content-wrap'>
        <Helmet>
          <title>{pageTitle('Value Streams')}</title>
        </Helmet>  
        {!wallmode && access && access.edit && (
          <Filter loading = {this.props.loading}
            threshold={this.state.threshold}
            changeThreshold={this.changeThreshold}
            dateRange={dateRange}
            changeDateRange={this.changeDateRange}
            controls={this.state.comparison}
            onApply={this.applyFilters}
            dashboards={filters.dashboards || []}
          />
        )}
        {this.state.comparison ? this.renderComparisonReport() : this.renderExecutiveReport()}
      </div>,
      trialExpired &&
      <div className='main expired' key="3">
        <Header showTeam={true} buttons={<SubscribeEDAddOn></SubscribeEDAddOn>}/>
        <div className='centerContent'>
          <div>
            <h1 className='title'>Your trial has expired</h1></div>
          </div>
        </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err)),
    getFilters: id => dispatch(getFilters(id)),
    setFilters: (id, data, returnData) => dispatch(setFilters(id, data, returnData)),
    requestData: id => dispatch(requestData(id)),
    requestComparisonData: (page, id) => dispatch(requestComparisonData(page, id)),
    getComparisonPdf: (percentile, threshold, id) => dispatch(getComparisonPdf(percentile, threshold, id)),
    getPdf: (id) => dispatch(getPdf(id)),
    getCsv: (id) => dispatch(getCsv(id)),
    select: (itemId, viewId) => dispatch(selectStream(itemId, viewId)),
    remove: (id) => dispatch(deleteStream(id)),
    listAllStreams: () => dispatch(listAll()),
    selectStream: (item, viewId) => dispatch(selectStream(item, viewId)),
    saveSelectedStream: (id) => dispatch(saveSelected(id)),
    saveSelectedBreakdown: (id, chart, value) => dispatch(saveSelectedBreakdown(id, chart, value)),
    saveSelectedDateRange: (id, dateRange) => dispatch(saveSelectedDateRange(id, dateRange))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    wallmode: state.app.wallmode,
    selected: state.report.selectedStream,
    filters: state.report.filters,
    dateRange: state.report.dateRange,
    loading: state.report.isLoading,
    comparisons: state.report.comparisons,
    stats: state.report.stats,
    trends: state.report.trends,
    streams: state.report.streams,
    selectedStream: state.report.selectedStream,
    noStreams: state.report.noStreams,
    loaded: state.report.loaded,
    user: state.auth.user,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports));
export { Reports };
